module.exports = __webpack_public_path__ + "static/media/CHAWMONASTERIO_MENU-normal.09a0330a.png";